export enum LocationEnum {
    MIDWEST = "widwest",
    NORTHEAST = "northeast",
   COASTAL_SOUTHEAST = "coastal southeast",
   SOUTHWEST = "southwest",
   PACIFIC_NORTHWEST = "pacific northwest",
   SOUTHEAST = "southeast"
}